<div class="wrapper">

  <!-- Pull to refresh loader -->
  @if (pullProgress() > 0 && !reloading()) {
    <div class="flex align-items-center justify-content-center mt-2 mb-2">
      <div class="pull-to-refresh-loader" [style.--progress]="pullProgress() + '%'"></div>
    </div>
  }

  <!-- Loading spinner -->
  @if (reloading()) {
    <div class="flex align-items-center justify-content-center mt-2 mb-2">
      <span class="loader"></span>
    </div>
  }

  <div class="container no-container-on-mobile">
    <app-navbar></app-navbar>
  </div>

  <main id="main">
    <div class="page-wrapper">
      <div class="page-content-wrapper">
        <div class="page-content">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>

  </main>
  <div class="container no-container-on-mobile">
    <app-bottombar></app-bottombar>
  </div>
</div>

<!-- New offers modal -->
<p-dialog header="Nuovo messaggio" (onHide)="message['visible'] = false" [(visible)]="message.visible"
  [breakpoints]="{ '960px': '75vw' }" [style]="{ width: '50vw' }" [modal]="true" [draggable]="false" [resizable]="false"
  [closable]="false">
  <div class="text-center mt-0">
    <h3 class="mb-1 mt-0">{{ message.title }}</h3>
    <p class="mt-0" [innerHTML]="message.text"></p>
  </div>
  <div class="mt-1">
    <div class="flex flex-row justify-content-end align-items-center mt-2">
      @if (message.url && message.url.includes('offer')) {
        <p-button label="Visualizza la proposta"
          (onClick)="router.navigate([message['url']])"></p-button>
      }
      @if (!message.url || (message.url && !message.url.includes('offer'))) {
        <p-button class="ml-2" severity="secondary" label="Chiudi"
          (onClick)="message['visible'] = false"></p-button>
      }
    </div>
  </div>
</p-dialog>